import { BuyOperation } from "../../../components/contractListItem/buy";
import { SellOperation } from "../../../components/contractListItem/sell";
import { USER_ROLE } from "../../../enums";
import { ESenderRole } from "../../../setup/api/services/contract/models";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { IContractProps } from "../models";

export const ContractType = (props: IContractProps) => {
  const userId = AuthConfig.getUserInfo().id;
  const { contract } = props;
  const renderContractType = {
    BUYER: <BuyOperation />,
    SELLER: <SellOperation />,
  };
  const getContractType = () => {
    if (
      (contract.senderId == userId &&
        contract.senderRole === ESenderRole.PROVIDER) ||
      (contract.senderId != userId &&
        contract.senderRole === ESenderRole.CUSTOMER)
    ) {
      return USER_ROLE.SELLER;
    } else {
      return USER_ROLE.BUYER;
    }
  };
  return renderContractType[getContractType()];
};
